import { FC, useState } from 'react'
import Checkbox from '~ui/Checkbox'
import classNames from 'classnames'

type FollowStarsProps = {
  id: string
  name: string
  img: string
  label: string
  onChange: (v) => void
}

const StarsCard: FC<FollowStarsProps> = ({ id, name, img, label, onChange }) => {
  const [checked, setChecked] = useState(false)

  const toggle = () => {
    setChecked((ch) => !ch)
    onChange?.(!checked)
  }

  return (
    <div>
      <button
        type="button"
        className="boorder-none w-full outline-none mb-5 hover:[&>img]:border-white"
        tabIndex={-1}
        onClick={toggle}
      >
        <img
          src={img}
          className={classNames(
            'object-cover w-full min-h-full border rounded-lg border-g-dividers',
            {
              'glow-box-indigo-300 border-white': checked,
            }
          )}
          alt={label}
        />
      </button>
      <Checkbox
        id={id}
        name={`${name}-${id}`}
        label={label}
        checked={checked}
        rounded="rounded-lg"
        onChange={(e) => {
          const isChecked = (e.target as HTMLInputElement).checked
          setChecked(isChecked)
          onChange?.(isChecked)
        }}
      />
    </div>
  )
}

export default StarsCard
